import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, Zap, FileText } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-8 pb-12 px-4 text-center" data-id="element-112">
      <div className="max-w-lg mx-auto" data-id="element-113">
        <h1 className="text-2xl md:text-3xl font-black text-white leading-[1.15] tracking-tight mb-4 drop-shadow-lg" data-id="element-114">
          El Kit Definitivo de RRHH para{' '}
          <span className="text-teal-300" data-id="element-115">Hospitales y Clínicas Privadas</span>
        </h1>

        <button type="button" onClick={() => document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth'
      })} aria-label="Ver la oferta del Kit RRHH Hospital" className="relative mx-auto block w-full max-w-sm mb-6 rounded-xl overflow-hidden shadow-2xl cursor-pointer hover:opacity-95 transition-opacity" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/a77Mj3MvRegaRzC3aSYw7R/ChatGPT_Image_Jul_5,_2026,_05_15_32_PM.png" alt="Kit RRHH Hospital" className="w-full h-auto object-cover" data-id="element-117" />
        </button>

        <h2 className="text-base md:text-lg font-medium text-slate-100 mb-5 leading-snug drop-shadow" data-id="element-118">
          Más de 20 herramientas listas para usar para organizar personal,
          reducir errores administrativos y prepararte para auditorías.
        </h2>

        <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-119">
          <div className="flex items-center gap-1.5 bg-teal-50 px-3 py-1.5 rounded-full" data-id="element-120">
            <FileText className="w-4 h-4 text-teal-600 flex-shrink-0" data-id="element-121" />
            <span className="text-sm font-semibold text-slate-800" data-id="element-122">
              100% PDF y Excel
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-teal-50 px-3 py-1.5 rounded-full" data-id="element-123">
            <Zap className="w-4 h-4 text-yellow-500 flex-shrink-0" data-id="element-124" />
            <span className="text-sm font-semibold text-slate-800" data-id="element-125">
              Entrega Inmediata
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-teal-50 px-3 py-1.5 rounded-full" data-id="element-126">
            <CheckCircle2 className="w-4 h-4 text-teal-600 flex-shrink-0" data-id="element-127" />
            <span className="text-sm font-semibold text-slate-800" data-id="element-128">
              +20 herramientas
            </span>
          </div>
        </div>

        <Button data-id="element-129">
          <span data-id="element-130">Quiero mi Kit RRHH en orden</span>
        </Button>
      </div>
    </section>;
}